/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../redux/auth/auth.action';

const ToastComponent = ({ toastMessage, showToast }) => {
  useEffect(() => {
    if (toastMessage.message) {
      // console.log('toast', toastMessage);
      toast(toastMessage.message, {
        type: toastMessage.type || 'default',
      });
      setTimeout(() => {
        showToast({
          show: false,
          message: '',
        });
      }, 5000);
    }
  }, [toastMessage]);
  return (
    <div className=''>
      <ToastContainer
        position='top-right'
        // autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        limit={1}
      />
    </div>
  );
};

const mapStateToProps = ({ authReducer: { toast } }) => ({
  toastMessage: toast,
});

const mapDispatchToProps = (dispatch) => ({
  showToast: (data) => dispatch(showToast(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToastComponent);
